<template>
  <EditModuleComponent />
</template>

<script>
// @ is an alias to /src
import EditModuleComponent from "@/sections/voiceplus/components/EditModuleComponent.vue";
import config from "@/config";

export default {
  name: "EditModule",
  components: {
    EditModuleComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
